/**
 * Auto-generated Zod schema for RepositoryVulnerabilityAlertCreateEvent
 * DO NOT MODIFY - regenerate with: bun run generate:schemas
 */

import type { RepositoryVulnerabilityAlertCreateEvent as RepositoryVulnerabilityAlertCreateEventOctokit } from '@octokit/webhooks-types';
import { z } from 'zod';

import {
  GitHubOrgSchema,
  OrganizationSchema,
  RepositorySchema,
  RepositoryVulnerabilityAlertAlertSchema,
} from './shared/index.js';

export const RepositoryVulnerabilityAlertCreateEventSchema = z.object({
  action: z.literal('create'),
  alert: RepositoryVulnerabilityAlertAlertSchema.and(
    z.object({
      state: z.literal('open'),
    }),
  ),
  repository: RepositorySchema,
  sender: GitHubOrgSchema,
  organization: OrganizationSchema.optional(),
}) satisfies z.ZodType<RepositoryVulnerabilityAlertCreateEventOctokit>;

export type RepositoryVulnerabilityAlertCreateEvent =
  RepositoryVulnerabilityAlertCreateEventOctokit;

export function isRepositoryVulnerabilityAlertCreateEvent(
  value: unknown,
): value is RepositoryVulnerabilityAlertCreateEvent {
  return RepositoryVulnerabilityAlertCreateEventSchema.safeParse(value).success;
}
